// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-wrapper {\n  width: 186px;\n  height: 181px;\n  border: 1px solid var(--ion-color-dark-tint);\n}\n\n.empty-wrapper {\n  height: 100%;\n  background: rgba(255, 255, 255, 0.62);\n}\n\nion-buttons {\n  background: white;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
